/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Pääsy resursseihin ja tukimateriaaleihin CamAPS FX:lle ja CamAPS Liberty®:lle.',
    keywords: 'camaps kirjasto, camaps fx, camaps liberty, tukiresurssit, diabeteksen hallinta',
    localeMeta: 'fi_fi',

    bannerTitle: 'Tuki numeroiden ulkopuolella',
    bannerSubtitle: 'CamAPS Liberty<sup>®</sup>:n kanssa',
    bannerDescription: 'Aktivoidessa käyttäjien ei tarvitse laskea hiilihydraatteja ja antaa ennen ateriaa insuliinibolusta.',
    bannerCompatibility: 'Yhteensopiva Android- ja iOS-järjestelmien kanssa',
    
    announcementText: 'Nyt saatavilla myLoopissa',
    announcementDisclaimer: '',

    introTitle: 'Ensimmäinen täysin suljetun silmukan ominaisuus. Kun tarvitset sitä.',
    introDescription: 'Kun se on aktivoitu, käyttäjien ei tarvitse laskea hiilihydraatteja ja antaa ateriaa edeltävää insuliinibolusta.',
    introSubtext: 'Saatavilla Android- ja Apple-käyttöjärjestelmissä',

    howItWorksTitle: 'Miten se toimii?',
    howItWorksDescription: 'Toimii proaktiivisemmalla versiolla CamAPS-algoritmista. CamAPS Liberty ennakoi ja vastaa glukoosimuutoksiin säilyttäen vakiintuneet turvarajat.',
    
    step1Title: 'VAIHE 1',
    step1Description: 'Siirry kotinäytöltäsi asetusvalikkoon.',
    step2Title: 'VAIHE 2',
    step2Description: 'Vieritä alaspäin ja napauta kytkintä aktivoidaksesi.',
    step3Title: 'VAIHE 3',
    step3Description: 'Ensimmäisellä käyttökerralla sinun täytyy katsoa CamAPS Liberty -selitysvideo.',
    step4Title: 'VAIHE 4',
    step4Description: 'Vahvista, että et ole alle 13-vuotias tai raskaana.',
    step5Title: 'VAIHE 5',
    step5Description: 'Napauta kytkintä uudelleen aktivoidaksesi.',
    step6Title: 'VAIHE 6',
    step6Description: "Kaikki valmista. CamAPS Liberty -välilehti näkyy kotinäytöllä<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Toimii vain, kun \"Auto mode\" on käytössä",

    eligibilityTitle: 'Kuka voi käyttää CamAPS Libertyä?',
    eligibilityCriterion1: 'Olemassa olevat käyttäjät, joilla on tyypin 1 diabetes',
    eligibilityCriterion2: '13 vuotta ja vanhemmat',
    eligibilityCriterion3: 'Raskaana',
    parentsCarersTitle: 'Entä vanhemmat ja hoitajat?',
    parentsCarersBlockTitle: '"Estä"-toiminto:',
    parentsCarersBlockDescription: 'Tahattoman käytön estämiseksi',
    parentsCarersRemoteTitle: 'Etäseuranta:',
    parentsCarersRemoteDescription: 'Companion, Glooko® ja CamAPS 2 viikon PDF-raportit',

    imageOverlayText: 'Suunniteltu toimimaan nykyisen diabeteshallintasuunnitelmasi rinnalla; ei korvaamaan sitä.',
    
    usingTitle: 'CamAPS Libertyn käyttö',
    
    treatmentPlanText: 'CamAPS Liberty on suunniteltu poistamaan rutiininomaisten ateriabolusten tarve. Se ei korvaa käyttäjän diabeteksen hoitosuunnitelman muita osia, mukaan lukien säännölliset arvioinnit diabeteshoitotiimin kanssa.',
    
    usingLibertyTitle: 'Katso ja opi CamAPS Libertysta',
    usingLibertyDescription: 'Tutustu videoihin ja opi lisää CamAPS Libertysta sekä aloittamisesta.',
    // latestVideoLabel removed
    moreVideosLabel: 'Lisää videoita',
    factsheetDownloadText: 'CamAPS Liberty -tiedote (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_fi.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Aloittaminen',
        description: 'Candice Ward selittää, miten CamAPS Liberty otetaan käyttöön.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/k0Sc4M5ywOk',
            title: 'Käytännön Vinkkejä: CamAPS Liberty',
            duration: '02:28',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'CamAPS Libertyn esittely',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Tuo fully closed-loop -tunne',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/GAA_g9AesIM',
            title: 'CamAPS Liberty -ominaisuus',
            duration: '03:48',
        }
    ],
    
    whatHappensNextTitle: 'Mitä tapahtuu seuraavaksi?',
    whatHappensNextText: 'Ajamme pilottia yhdessä markkinassa tulevina kuukausina. Pysy kuulolla lisätietoja varten.',
};

